/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentType { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Código de 2 letras que cierra el código del documento (PO, PR, IO, FO)
     */
    code: string;
    name: string;
    /**
     * Política de descarga por defecto que heredan los documentos del tipo
     */
    allowDownloadDefault?: boolean;
    displayOrder?: number;
    active?: boolean;
}

